import { useEffect, useState } from "react";
import { LuCloudCog } from "react-icons/lu";
import { MdOutlineCloudDownload } from "react-icons/md";
import Button from "../../../components/Button/Button";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useAuth } from "../../../contexts/auth";
import FormBackup from "../FormBackup/FormBackup";
import ListBackup from "../ListBackup/ListBackup";
import "./ConsultaBackup.css";
import { useUserStore } from "../../../contexts/userStore";
import UploadBackup from "../UploadBackup/UploadBackup";
import { FiUploadCloud } from "react-icons/fi";
import { ConfigBackup } from "../ConfigBackup/ConfigBackup";
import { useListManager } from "../../../contexts/list.manager";
import { ServiceUnavailble } from "../../../components/ServiceUnavailble/ServiceUnavailble";
import { useLocation, useNavigate } from "react-router-dom";
import { AxiosError } from "axios";

const ConsultaBackup = () => {
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState([""]);
	const [modalConfigIsOpen, setModalConfigIsOpen] = useState(false);
	const { lineSelected } = useListManager();
	const { user, can } = useAuth();
	const { selectedCondominio: selelectedUnitId, licences, filterWithLicensesUnits } = useUserStore();
	const [selectedCondominio, setSelectedCondominio] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [optionsCondominios, setOptionsCondominios] = useState([]);
	const [modalUploadIsOpen, setModalUploadIsOpen] = useState(false);
	const [error, setError] = useState(null);
	const [refreshKey, setRefreshKey] = useState(0);

	useEffect(() => {
		if (location.state?.deletedId) {
			setRefreshKey((k) => k + 1);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	useEffect(() => {
		async function fetchCondominios() {
			const condominiosSelect = filterWithLicensesUnits();
			setOptionsCondominios(condominiosSelect.map(unit => ({
				value: unit.id,
				text: unit.name,
			})));
			if (condominiosSelect?.length) {
				setSelectedCondominio(condominiosSelect.find(unit => selelectedUnitId === Number(unit.id)).id);
			}
		}
		fetchCondominios();
	}, [user, selelectedUnitId, licences, filterWithLicensesUnits]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<MdOutlineCloudDownload size={20} />}
					title="Backups"
					hideAddButton={true}
					aditionalButton1={
						(can('bravas.backup.management.upload')) && !error && (
							<Button
								className="button-white"
								icon={<FiUploadCloud />}
								label="Upload"
								onClick={() => { setModalUploadIsOpen(true) }}
							/>
						)
					}
					aditionalButton2={
						(can('bravas.backup.config.update')) && !error && (
							<Button
								icon={<LuCloudCog size={20} />}
								label="Configurações de Backup"
								className="button-blue backup-settings-button"
								onClick={e => setModalConfigIsOpen(true)}
							/>
						)
					}
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar por Nome"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					{!(error instanceof AxiosError) ? (
						<ListBackup filters={filters} setError={setError} error={error} refreshKey={refreshKey} />
					) : (
						<ServiceUnavailble error={error} />
					)}
				</Container>
			</div>
			<ConsultaFormContainer>
				{!error && (
					<FormBackup type="consulta" backup={lineSelected} />
				)}
			</ConsultaFormContainer>

			<ConfigBackup optionsCondominios={optionsCondominios} modalIsOpen={modalConfigIsOpen} handleCancel={setModalConfigIsOpen} />
			<UploadBackup optionsCondominios={optionsCondominios} modalIsOpen={modalUploadIsOpen} handleCancel={setModalUploadIsOpen} />
		</div>
	);
};

export default ConsultaBackup;
